import { map as rxjsmap } from 'rxjs';
import { Subject } from 'rxjs';

import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Timetable, TypeOfWork } from '../models/timetable';
import { BaseServices } from './../../kuba.services';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TimetableServices {
  private setparent = new Subject<any>();
  getParent$ = this.setparent.asObservable();
  private setReadOnly = new Subject<any>();
  getReadOnly$ = this.setReadOnly.asObservable();
  constructor(private http: HttpClient) {}

  getReadOnly(path: boolean) {
    this.setReadOnly.next(path);
  }
  getParent(path: boolean) {
    this.setparent.next(path);
  }
  getAllByEach(id: number, key: string) {
    if (key) {
      return this.http
        .get(
          `${environment.BASE_URL}/${BaseServices.apiRoute(
            key
          )}/timetable/list/${id}`
        ).pipe(rxjsmap((result: any) => result));
    } else {
      return this.getAllTimetableByBusinessId();
    }
  }
  getAllTimetableByBusinessId() {
    return this.http
      .get(environment.BASE_URL + '/timetables/' + BaseServices.BusinessId).pipe(rxjsmap(result => result));
  }

  addTimetable(timetable: Timetable, key: string) {
    return this.http
      .post(`${environment.BASE_URL}/timetable`, timetable).pipe(rxjsmap(result => result));
  }

  // Update Timetable
  updateTimetable(id: number, timetable: Timetable) {
    return this.http
      .put(environment.BASE_URL + '/timetable/' + id, timetable).pipe(rxjsmap(result => result));
  }
  getAllTimetableByProjectId(projectId) {
    return this.http
      .get(environment.BASE_URL + '/timetables/' + projectId).pipe(rxjsmap(result => result));
  }

  getEmpByBusinessId(id) {
    return this.http
      .get(environment.BASE_URL + '/employees/' + id)
      .toPromise()
      .then((response: any) => {
        return response;
      });
  }
  getProByBusinessId(id) {
    return this.http
      .get(environment.BASE_URL + '/project/getall/' + id)
      .toPromise()
      .then((response: any) => {
        return response;
      });
  }

  getTypeofworkbyBusinessId(id) {
    return this.http
      .get(environment.BASE_URL + '/typeofworks/' + id).pipe(rxjsmap((result: any) => result));
  }

  getTypeofworkbyProjectId(id) {
    return this.http
      .get(environment.BASE_URL + '/timetables/' + id)
      .toPromise()
      .then((response: any) => {
        return response;
      });
  }
  getById(id) {
    return this.http
      .get(environment.BASE_URL + '/timetable/' + id).pipe(rxjsmap((result: any) => result));
  }

  // bind type
  getAllByType(id: number, key: string) {
    return this.http
      .get(environment.BASE_URL + `/typeofworks/` + id).pipe(rxjsmap(result => <TypeOfWork[]>result));
  }

  // update  Type
  updateType(data: TypeOfWork, key: number) {
    return this.http
      .put(environment.BASE_URL + `/typeofwork/` + data.Id, data).pipe(rxjsmap(result => result));
  }

  // adding Type
  createType(newCategory: TypeOfWork, key: number) {
    return this.http
      .post(environment.BASE_URL + `/typeofwork`, newCategory).pipe(rxjsmap(result => result));
  }

  // delete  Type
  deleteType(Id) {
    return this.http
      .delete(environment.BASE_URL + '/typeofwork/' + Id).pipe(rxjsmap(result => result));
  }

  getType(id: number) {
    return this.http
      .get(environment.BASE_URL + '/typeofworks/' + id).pipe(rxjsmap(result => result));
  }

  getallTypeofworks() {
    return this.http
      .get(environment.BASE_URL + '/typeofworks/' + BaseServices.BusinessId).pipe(rxjsmap(result => result));
  }

  getallApprovalPerson() {
    return this.http
      .get(environment.BASE_URL + '/users')
      .toPromise()
      .then((response: any) => {
        return response;
      });
  }
  getEmployeeContactUser() {
    return this.http
      .get(
        environment.BASE_URL +
          '/employeecontactusers/' +
          BaseServices.BusinessId
      )
      .toPromise()
      .then((response: any) => {
        return response;
      });
  }
  DeleteTimetable(id) {
    return this.http
      .delete(environment.BASE_URL + '/timetable/' + id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  DeleteTypeofwork(id) {
    return this.http
      .delete(environment.BASE_URL + '/typeofwork/' + id)
      .toPromise()
      .then((response: any) => {
        return response;
      });
  }

  getTimeTableByTimeTableId(
    timeTableId: number,
    featureId: number,
    featureKey: number
  ) {
    return this.http.get(
      environment.BASE_URL +
        '/timetablebytimetableid/' +
        timeTableId +
        '/' +
        featureId +
        '/' +
        featureKey
    );
  }

  /**
   * This method is used to get the list of all the origins that the user is connected to
   * @param businessId BusinessId of the user
   * @param language Language of the user
   * @param employeeId EmployeeId of the user
   * @returns A list of all the origins that the user is connected to
   */
  getMyPageOrigin(businessId: number, language: string, employeeId?: number) {
    const url =
      `${environment.BASE_URL}/myPageOrigin/${businessId}/${language}` +
      (employeeId ? `/${employeeId}` : 0);

    return this.http.get(url).pipe(rxjsmap(result => result));
  }

  /**
   * Get paginated timetable list
   * @param businessId Business ID (required) - defines the scope of access
   * @param filter Pagination and filter criteria (use filter.EmployeeName to filter by employee name)
   * @returns Observable with paginated response
   */
  getPagedTimetables(businessId: number, filter: any): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL}/timetables/paged?businessId=${businessId}`,
      filter
    );
  }

  /**
   * Export timetables with current filters and sorting
   * @param businessId Business ID (required) - defines the scope of access
   * @param filter Filter criteria (use filter.EmployeeName to filter by employee name)
   * @param type Export format (XLSX, DOCX, PDF)
   * @param headerName Header name for the export
   * @param mode Export mode (0 = portrait, 1 = landscape)
   * @param cultureInfo Culture info for formatting
   * @returns Observable with blob data
   */
  exportTimetablesToExcel(
    businessId: number,
    filter: any,
    type: string,
    headerName: string,
    mode: number,
    cultureInfo: string
  ): Observable<Blob> {
    const body = {
      Filters: filter,
      ColumnNames: [
        { title: 'Employee Name', dataKey: 'EmployeeName' },
        { title: 'Work Type', dataKey: 'ProjectWorkTypeName' },
        { title: 'Origin', dataKey: 'ProjectName' },
        { title: 'Start Date', dataKey: 'StartDate' },
        { title: 'End Date', dataKey: 'EndDate' },
        { title: 'Start Time', dataKey: 'StartTime' },
        { title: 'End Time', dataKey: 'EndTime' },
        { title: 'Break Time', dataKey: 'BreakTime' },
        { title: 'Hours Spent', dataKey: 'HoursSpent' },
        { title: 'Approver', dataKey: 'ApproverNameList' },
        { title: 'Status', dataKey: 'StatusText' },
        { title: 'Comments', dataKey: 'Title' },
      ],
    };
    
    return this.http.post(
      `${environment.BASE_URL}/timetables/export-all/${type}/${encodeURIComponent(headerName)}/${mode}/${businessId}/${cultureInfo}`,
      body,
      { responseType: 'blob' }
    );
  }
}
